import { IconProps } from 'utils/global.types';

export const ThreeDots = (props?: IconProps) => {
  return (
    <svg
      fill="currentColor"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      strokeWidth="0"
      viewBox="0 0 16 16"
      {...props}
    >
      <path d="M3 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3m5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3m5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3"></path>
    </svg>
  );
};
